import {lazy} from 'react';

export const MapSmallLazy = lazy(() => import(/* webpackChunkName: "mapSmall" */ '.'));
